import React from 'react'

const NewsItemTitle = ({ postItem, postItemHome }) => {
  // Validation des props et gestion des cas limites
  if (!postItem || typeof postItem !== 'object') {
    return null
  }

  // Fonction pour nettoyer le HTML et extraire le texte
  const cleanHtmlText = (htmlString) => {
    if (!htmlString || typeof htmlString !== 'string') {
      return ''
    }
    
    // Suppression des balises HTML pour l'accessibilité
    const cleanText = htmlString.replace(/<[^>]*>/g, '')
    
    // Retourner null si le texte est vide après nettoyage
    return cleanText.trim() || null
  }

  // Fonction pour obtenir le titre principal
  const getMainTitle = () => {
    // Priorité 1: highlight.post_title
    if (postItem.highlight && postItem.highlight.post_title) {
      const cleanTitle = cleanHtmlText(postItem.highlight.post_title)
      if (cleanTitle) {
        return {
          title: postItem.highlight.post_title,
          cleanTitle,
          source: 'highlight'
        }
      }
    }
    
    // Priorité 2: _source.post_title
    if (postItem._source && postItem._source.post_title) {
      const cleanTitle = cleanHtmlText(postItem._source.post_title)
      if (cleanTitle) {
        return {
          title: postItem._source.post_title,
          cleanTitle,
          source: 'source'
        }
      }
    }
    
    return null
  }

  const titleData = getMainTitle()
  
  if (!titleData) {
    return null
  }

  const { title, cleanTitle, source } = titleData
  
  // Classes CSS conditionnelles
  const titleClasses = [
    'news-list-item-title',
    postItemHome ? 'news-list-home-item-title' : ''
  ].filter(Boolean).join(' ')

  return (
    <h2 
      className={titleClasses}
      dangerouslySetInnerHTML={{ __html: title }}
      aria-label={`Titre de l'actualité: ${cleanTitle}`}
    >
      {/* Le contenu HTML sera rendu par dangerouslySetInnerHTML */}
    </h2>
  )
}

export default NewsItemTitle